export default [
    {
        "id": "manufacturersSlider-1",
        "plugin": "manufacturer",
        "pluginId": 7,
        "name": "manufacturer-brand",
        "html": require('./manufacturersSliders/manufacturersSlider-1/html').default,
        "svgContent": require('./manufacturersSliders/manufacturersSlider-1/svgContent').default,
        "svgViewBox": "0 0 1440 200",
        "svgContentMobile": require('./manufacturersSliders/manufacturersSlider-1/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 176",
        "js": require('./manufacturersSliders/manufacturersSlider-1/js').default,
        "minJs": require('./manufacturersSliders/manufacturersSlider-1/minJs').default
    }
]